import { render, staticRenderFns } from "./DialogBase.vue?vue&type=template&id=2c972206&scoped=true&"
import script from "./DialogBase.vue?vue&type=script&lang=ts&"
export * from "./DialogBase.vue?vue&type=script&lang=ts&"
import style0 from "./DialogBase.vue?vue&type=style&index=0&id=2c972206&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c972206",
  null
  
)

export default component.exports